import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { useGetContractsQuery } from '../../api/contracts/contractApiSlice';
import type { ApiAssetInfo } from '../../api/tags/tag.types';
import { fetchAssets } from '../../api/tags/tagCalls';
import LoadingErrorState from '../../common/error/LoadingErrorState';
import { BookingOverviewStats } from './BookingOverviewStats';
import { getBookingOverviewStatistics } from './bookingOverviewService';

export function BookingOverviewContainer() {
    const { data: contracts, isError: hasContractsError } = useGetContractsQuery(undefined);
    const [assets, setAssets] = useState<ApiAssetInfo[]>();
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        let isMounted = true;
        fetchAssets()
            .then(assets => {
                if (isMounted) {
                    setAssets(assets);
                }
            })
            .catch(() => {
                if (isMounted) {
                    setHasError(true);
                }
            });

        return () => {
            isMounted = false;
        };
    }, []);

    if (hasError || hasContractsError) {
        return <LoadingErrorState />;
    }

    if (!contracts || !assets) {
        return <Spinner text={<FormattedMessage id='intl-msg:marketplace.loading' />} isInverse={false} />;
    }

    return <BookingOverviewStats statistics={getBookingOverviewStatistics(contracts, assets)} />;
}
